import {useState,useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import PasswordStrengthBar from 'react-password-strength-bar';

import {TenantFrontendApi_DeleteUserLicence,TenantFrontendApi_GetLicenceList,TenantFrontendApi_GetTenant, TenantFrontendApi_GetUser,TenantFrontendApi_UpdateUser,TenantFrontendApi_DeleteUser, TenantFrontendApi_ChangeUserPassword,TenantFrontendApi_ChangeUserLicense} from "./TenantFrontendApi";
import { Translate } from "./Translator"
import Header from "./Header"
import MainMenu from "./MainMenu";
import Footer from "./Footer"
import BlueBar from "./BlueBar";

import HomeLogo from "./Assets/HomeLogo.png"
import CloseLogo from "./Assets/CloseLogo.jpg"

import './Tenant.css';
import './EditUser.css';

function EditUser(){

    const navigate = useNavigate();
    const [mRepaint,SetRepaint]=useState(false)
    const [mUser,SetUser]=useState()
    const [mUserGuid,SetUserGuid]=useState()
    const [mUpdateResult,SetUpdateResult] = useState("")
    const [mUpdateSuccessfully,SetUpdateSuccessfully] = useState(false)
    const [mUserPassword,SetUserPassword] = useState("")
    const [mConfirmPassword,SetConfirmPassword] = useState("")
    const [mChangePasswordResult,SetChangePasswordResult] = useState("")
    const [mChangePasswordSuccessfully,SetChangePasswordSuccessfully] = useState(false)
    const [mPasswordVisible, SetPasswordVisible] = useState(false)
    const [mLicenceList,SetLicenceList] = useState([])
    const [mLicenceGuid,SetLicenceGuid] = useState("")
    const [mExpireLicence,SetExpireLicence] = useState("")
    
    const [mTenantGuid,SetTenantGuid]=useState()
    const [mTenant, SetTenant] = useState("")

    const [mAssignNewLicenceError,SetAssignNewLicenceError] = useState("")


    useEffect(() => {

        async function GetUser(aUserGuid) {
            try
            {  
                console.log("Getting user")
                const UserResponse = await TenantFrontendApi_GetUser(sessionStorage.getItem("token"),aUserGuid)
                //console.log(UserResponse.data)
                SetUser(UserResponse.data)
                SetLicenceGuid(UserResponse.data.LicenceGuid)
            }
            catch (ex)
            {
                var error = ex;
                var errorCode = null;
                try 
                {
                    if (ex.response && ex.response.status) {
                        errorCode = ex.response.status;
                        console.log(errorCode)
                    }
                    navigate('../error?errorcode=' + errorCode + '&error=user')
                    error = ex.response.data.Exception;
                } catch {}  
                console.log("Error: " + error);
            }
        }

        async function GetTenant(aTenantGuid) {
            try
            {
                console.log("Getting tenant")
                const TenantResponse = await TenantFrontendApi_GetTenant(sessionStorage.getItem("token"),aTenantGuid)
                SetTenant(TenantResponse.data)
            }
            catch (ex)
            {
                var error = ex;
                var errorCode = null;
                try 
                {
                    if (ex.response && ex.response.status) {
                        errorCode = ex.response.status;
                        console.log(errorCode)
                    }
                    navigate('../error?errorcode=' + errorCode + '&error=tenant')
                    error = ex.response.data.Exception;
                } catch {}  
                console.log("Error: " + error);
            }
        }

        async function GetLicenceList() {
            try
            { 
                //console.log("Getting Licences")
                const LicenceListResponse = await TenantFrontendApi_GetLicenceList(sessionStorage.getItem("token"))
                //console.log(JSON.stringify(LicenceListResponse))
                SetLicenceList(LicenceListResponse.data)
            }

            catch (ex)
            {
                var error = ex;
                try { error = ex.response.data.Exception; } catch {}  
                console.log("Error: " + error);
            }
        }

        //Get the parameters from the URL
        const windowUrl = window.location.search;
        const params = new URLSearchParams(windowUrl);
        const ciParams = new URLSearchParams();
        for (const [name, value] of params) { ciParams.append(name.toLowerCase(), value); }
        const userguid = ciParams.get('userguid')
        const tenantguid = ciParams.get('tenantguid')
        SetUserGuid(userguid)
        SetTenantGuid(tenantguid)
        GetLicenceList()

        GetUser(userguid)
        if (tenantguid)
        {
            GetTenant(tenantguid)
        }
        
    }, [navigate]);

    const SetName = (aName) => {
        if(mUser)
        {
            mUser.Name = aName
            SetRepaint(!mRepaint)
        }
    }

    const SetEmail = (aEmail) => {
        if(mUser)
        {
            mUser.Email = aEmail
            SetRepaint(!mRepaint)
        }

    }

    const SetUserApiSetting = (aUserApiSetting) => {
        //let UpdatedApiSetting = aUserApiSetting.replace(/\r\n/g, '*break*');
        //UpdatedApiSetting = UpdatedApiSetting.replace(/\n/g, /\r\n/);
        //UpdatedApiSetting = UpdatedApiSetting.replace('*break*', /\r\n/);
        //const UpdatedApiSetting = aUserApiSetting.replace(/\n/g, '\r\n');
        SetUser((prevUser) => ({
            ...prevUser,
            ApiSettings: aUserApiSetting
        }));
        SetRepaint(!mRepaint);
    }

    const SetIsRecognitionAdmin = (aIsRecognitionAdmin) =>{
        mUser.IsRecognitionAdmin = aIsRecognitionAdmin
        SetRepaint(!mRepaint)
    }

    const SetIsTenantAdmin = (aIsTenantAdmin) =>{
        mUser.IsTenantAdmin = aIsTenantAdmin
        SetRepaint(!mRepaint)
    }

    const SetSaveUserSettingsResultShow = (aMessage) =>{
        //
    }

    const SetPressSaveUserSettings = (aFlag) =>{
        //
    }

    async function UpdateUser() {

        try
        {
            console.log("Updating user")
            const UpdateUserResponse = await TenantFrontendApi_UpdateUser(sessionStorage.getItem("token"),mUser.UserGuid,mUser.Email,mUser.Name,mUser.ApiSettings,mUser.IsRecognitionAdmin,mUser.IsTenantAdmin,mUser.TenantGuid,mLicenceGuid)
            console.log(JSON.stringify(UpdateUserResponse))
            SetSaveUserSettingsResultShow("The user updated successfully")
            SetUpdateResult("The user updated successfully")
            SetUpdateSuccessfully(true)
            if(mTenantGuid)
            {
                navigate('../tenant?tenantguid=' + mTenantGuid)
            }
            else
            {
                navigate('../user?userguid=' + mUserGuid + '&tenantguid=' + mTenantGuid)

            }
        }

        catch (ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
            SetSaveUserSettingsResultShow("The user is not updated !")
            SetUpdateResult("You are not allow to assign this license to current user")
            SetUpdateSuccessfully(false)
        }
    }

    async function DeleteUser() {
        try
        {
            console.log("Deleting user")
            const DeleteUserResponse = await TenantFrontendApi_DeleteUser(sessionStorage.getItem("token"),mUser.UserGuid)
            console.log(DeleteUserResponse)
            if(mTenantGuid)
            {
                navigate('../tenant?tenantguid=' + mTenantGuid)
            }
            else
            {
                navigate('../users')

            }
        }
        catch (ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception;
                console.log(ex.response.data)
             } catch {}  
            console.log("Error: " + error);
        }
    }

    async function ChangeUserPassword(){
        try
        {
            console.log("Changing user password")
            const ChangeUserPasswordResponse = await TenantFrontendApi_ChangeUserPassword(sessionStorage.getItem("token"),mUserGuid,mUserPassword,mTenantGuid)
            console.log(JSON.stringify(ChangeUserPasswordResponse))
            SetChangePasswordResult("The user password is updated successfully")
            SetChangePasswordSuccessfully(true)
        }

        catch (ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
            SetChangePasswordResult("The user password is not updated correctlly")
            SetChangePasswordSuccessfully(false)
        }
    }

    function handleSaveUserSettings(){
        SetPressSaveUserSettings(true)
        return(
            UpdateUser()
        )
       
    }

    function handleChangePassword(){

        if(mUserPassword && mConfirmPassword)

        {
            if(mUserPassword === mConfirmPassword)
            {
                return(ChangeUserPassword())
            }

            else
            {
                //the passwords are not same 
                SetChangePasswordSuccessfully(false)
                SetChangePasswordResult("The passwords are not same")

            }  
        }
        else
        {
            SetChangePasswordSuccessfully(false)
            SetChangePasswordResult("Both fields should be fill it")  
            
        }
    }

    function handleDeleteUser()
    {
        return(DeleteUser())  
    }
        

    function languageChanged(){
        SetRepaint(!mRepaint)
    }

    function ExpireLicence()
    {
        DeleteUserLicence()
    }

    async function DeleteUserLicence()
    {
        try{
            console.log("Deleting Licence")
            const DeleteLicecnceResponse = await TenantFrontendApi_DeleteUserLicence(sessionStorage.getItem("token"),mUserGuid,mUser.TenantGuid)
            console.log(DeleteLicecnceResponse)
            SetExpireLicence("")
            navigate('../user?userguid=' + mUserGuid + "&tenantguid=" + mUser.TenantGuid)
            SetRepaint(!mRepaint)
        }
        catch(ex)
        {
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
        }
    }

    async function AssignNewLicense()
    {
        try{
            console.log("Assigning new licence")
            if(mLicenceGuid === "None")
            {
                DeleteUserLicence()
            }
            else
            {
                const AssignNewLicenseResponse = await TenantFrontendApi_ChangeUserLicense(sessionStorage.getItem("token"),mUserGuid,mUser.TenantGuid,mLicenceGuid)
                console.log(AssignNewLicenseResponse.data)
                SetLicenceGuid("")
                navigate('../user?userguid=' + mUser.UserGuid)
            }
        }
        catch(ex)
        {
            var error = ex;
            
            try { error = ex.response.data.Exception;
                console.log(ex.response.data)
                SetAssignNewLicenceError(ex.response.data)
             } catch {}  
            console.log("Error: " + error);
        } 

    }
    
        let PageLocation = <span/>
        if (mTenantGuid)
        {
            PageLocation = <tr height="60">
                <td width="40" align="left">
                    <span width="20" align="left"><img alt="Home logo" className="HomeLogo pointer" src={HomeLogo} onClick={() => navigate('/')}/></span>              
                    <span className="underline pointer bold" width="20" align="left" onClick={() => navigate('../tenant?tenantguid=' + mTenantGuid)}>{mTenant.Company}</span>
                    <span width="20" className="blue" align="center"> / </span>
                    <span className="underline pointer bold" width="40" align="left" text-align="button" onClick={() => navigate('../tenantusers?tenantguid=' + mTenantGuid)}>{Translate("Users")}</span>
                    <span width="20" className="blue" align="center"> / </span>
                    <span width="50" align="left" className="bold underline pointer" onClick={()=>navigate('../user?userguid=' + mUserGuid + '&tenantguid=' + mTenantGuid)}>{mUser ? mUser.Name : ''}</span>
                    <span width="20" className="blue" align="center"> / </span>
                    <span className="bold">{Translate("Edit")}</span>
                </td>
            </tr>
        }
        else
        {
            PageLocation = <tr height="60">
                <td width="40" align="left">
                    <span width="20" align="left"><img alt="Home logo" className="HomeLogo pointer" src={HomeLogo} onClick={() => navigate('/')}/></span>
                    <span className="underline pointer bold" width="40" align="left" text-align="button" onClick={() => navigate('../users')}>{Translate("Users")}</span>
                    <span width="20" className="blue" align="center"> / </span>
                    <span width="50" align="left" className="bold">{mUser ? mUser.Name : ''}</span>
                    <span width="20" className="blue" align="center"> / </span>
                    <span className="bold">{Translate("Edit")}</span>
                </td>
            </tr>
        }


        return(
            
            <span>

                <Header onLanguageChanged={() => languageChanged()}/>
                
                <MainMenu MainMenuNumber={2} />

                <table width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>

                    <tr className="pagetop3">
                        <td height="75" valign="bottom">
                            <table width="100%" cellPadding={0} cellSpacing={0} className="down10px">
                                <tbody>
                                    {PageLocation}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
                </table>

                <table width="1200" cellPadding={0} cellSpacing={0} align="center" >
                    <tbody>                

                        <tr className="pagetop4">
                            <td colSpan={4} height="75" valign="left" className="activetenants width30">
                                {Translate("User settings")}
                            </td>
                        </tr>

                        <tr className="pagetop4">
                            <td colSpan={4} className="horizontalLine width30" >
                                <BlueBar/>
                            </td>
                        </tr>

                        <tr height="50"/>                
                    </tbody>
            </table>

                <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>

                    <tr height="20" ></tr>
                   
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizelarge">{Translate("Main settings")}</td>
                        <td></td>
                    </tr>
                    
                    <tr height="20"/>
                    
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall">{Translate("Name")}</td>
                    </tr>
                   
                   <tr height="10"/>

                    <tr height="40">
                        <td width="40"></td>
                        <td width="1000"><input value={mUser ? mUser.Name: ''} onChange={e=>SetName(e.target.value)} className="inputtd"></input></td>
                        <td></td>
                    </tr>

                    <tr height="20"/>
                
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall">{Translate("Email")}</td>
                    </tr>
                   
                    <tr height="10"/>

                    <tr height="40">
                        <td width="40"></td>
                        <td width="1000"><input value={mUser ? mUser.Email : '' } onChange={e=>SetEmail(e.target.value)} className="inputtd"></input></td>
                        <td></td>
                    </tr>

                    <tr height="20"/>


                    <tr height="20"></tr>

                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall">{Translate("User API settings")}</td>
                    </tr>
                   
                    <tr height="10"/>

                    <tr height="80">
                        <td width="40"></td>
                        <td><textarea value={mUser ? mUser.ApiSettings : ''} onChange={e=>SetUserApiSetting(e.target.value)} className="textareaedituser"></textarea></td>
                        <td></td>
                    </tr>

                   <tr height="20"/>
                
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall"><input checked={mUser ? mUser.IsRecognitionAdmin : false} onChange={e=>SetIsRecognitionAdmin(e.target.checked)} type="checkbox"/>
                            <span> </span> 
                            {Translate("CRM Integration Admin; required to configure the CRM integration settings of the user’s organization.")}
                        </td>
                    </tr>

                    <tr height="20"/>
                
                    <tr>
                        <td width="40"></td>
                        <td className="bold fontsizesmall"><input checked={ mUser ? (mUser.IsTenantAdmin === true) : false} onChange={e=>SetIsTenantAdmin(e.target.checked)} type="checkbox"/> 
                        <span> </span>
                        {Translate("User Account Admin; required to configure the organization’s other user accounts.")}
                    </td>
                </tr>
                
                <tr height="20"/>

                <tr>
                    <td width="40"></td>
                    {mUpdateSuccessfully ? <td className="bold green">{mUpdateResult}</td> : <td className="bold red">{mUpdateResult}</td>}
                </tr>

                <tr height="15"></tr>
                
                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">
                        <button className="blackbackground white pointer borderradios buylicencebutton btn btn-dark" onClick={()=> handleSaveUserSettings()}>{Translate("Save user settings")}</button> 
                    </td>
                </tr>
                   
                <tr height="20"/>       
            </tbody>
            </table>
            
            {/*Free space*/}
            <table>
                <tbody>
                    <tr height="60"/>
                </tbody>
            </table>

            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>

                    <tr height="20" ></tr>
                   
                    <tr>
                       <td width="40"></td>
                       <td className="bold fontsizelarge">{Translate("License settings")}</td>
                       <td></td>
                    </tr>

                    <tr height="20" ></tr>

                <tr>
                    <td width="40"></td>
                    <td className="bold">{Translate("Choose a new option from the list to change the license")}</td>
                </tr>

                <tr height="20"/>
                
                <tr height="40">
                    <td width="40"></td>
                        <td width="1000">
                            <select
                                className="inputtd" onChange={e=>{SetLicenceGuid(e.target.value);SetRepaint(!mRepaint)}}>
                                    <option value={mUser ? (mUser.LicenceGuid ? mUser.LicenceGuid : "" ) : "" }>{mUser?.LicenceGuid ? mUser.LicenceName : "Please choose a license"}</option>
                                    <option value="None">{Translate("None")}</option>
                                    {mLicenceList.map((licence) => (
                                        <option key={licence.id} value={licence.LicenceGuid}>
                                            {licence.Name}
                                        </option>
                                    ))}
                            </select>
                    </td>
                </tr>
                
                <tr height="20"/>
                
                <tr>
                    <td width="40"/>
                    <button disabled={ mUser?.LicenceGuid ? ((mLicenceGuid !== mUser.LicenceGuid) ? false : true) : false } className="blackbackground white pointer borderradios buylicencebutton btn btn-dark" onClick={()=> AssignNewLicense()}>{Translate("Change license")}</button> 

                </tr>
                
                   
                <tr height="20"/>
            </tbody>
            </table>
            
            <table>
                <tbody>
                    <tr height="80"/>
                </tbody>
            </table>



            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
            <tbody>

                <tr height="20" ></tr>
                   
                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizelarge">{Translate("Change password")}</td>
                    <td></td>
                </tr>
                
                <tr height="20"/>
                
                <tr>
                    <td width="40"></td>
                    <td>
                        {Translate("New password must comply with the following")}
                    </td>
                </tr>
                
                <tr height="8"/>
                   
                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td width="8"/>
                                    <td className="dot"></td>
                                    <td className="fontsizesmall paddingleft">{Translate("Must contain between 8 and 50 characters")}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="8"/>
                
                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td width="8"/>
                                    <td className="dot"></td>
                                    <td className="fontsizesmall paddingleft">
                                        {Translate("Must contain at least 1 letter")}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="8"/>

                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td width="8"/>
                                    <td className="dot"></td>
                                    <td className="fontsizesmall paddingleft">
                                        {Translate("Must contain at least 1 digit")}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="8"/>
                   
                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td width="8"/>
                                    <td className="dot"></td>
                                    <td className="fontsizesmall paddingleft">
                                        {Translate("Must contain at least 1 special character [~`!@#$%^&*()_+=|[]:;']")}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="20"></tr>

                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">{Translate("Password")} <span className="red"> *</span></td>
                </tr>
                   
                <tr height="10"/>

                <tr height="40">
                    <td width="40"></td>
                    <td><input type={mPasswordVisible ? "text" : "password"}  onChange={e=>SetUserPassword(e.target.value)} className="inputtd"></input>
                        <span className="passwordtoggleicon" onClick={() => SetPasswordVisible(!mPasswordVisible)}>{mPasswordVisible ? '👁️' : '👁️‍🗨️'} </span>
                    </td>
                    <td></td>
                </tr>

                <tr height="20"/>

                <tr>
                    <td width="40"></td>
                    <td width="100"><PasswordStrengthBar password={mUserPassword} /></td>
                </tr> 

                <tr height="20"/>

                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">{Translate("Confirm new password")} <span className="red"> * </span></td>
                </tr>
                   
                <tr height="10"/>

                <tr height="40">
                    <td width="40"></td>
                    <td><input type="password" onChange={e=>SetConfirmPassword(e.target.value)} className="inputtd"></input></td>
                    <td></td>
                </tr>

                <tr height="20"></tr>

                <tr>
                    <td width="40"/>
                        {mChangePasswordSuccessfully ? <td className="green bold">{mChangePasswordResult}</td> : <td className="red bold">{mChangePasswordResult}</td> }
                </tr>

                <tr height="15"></tr>
                
                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">
                        <button className="saveusersettingsbutton bold" onClick={()=>handleChangePassword()}>{Translate("Change password")}</button> 
                    </td>
                </tr>
                
                <tr height="20"/>       
                </tbody>
            </table>

            <br/>
            <br/>

            {/*Delet User Table*/}
            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
            <tbody>

                <tr height="20" ></tr>
                
                <tr>
                    <td width="40"></td>
                    <td>
                        <table>
                            <tbody>
                                <tr>
                                    <td><img alt="Close logo" width="20" src={CloseLogo}/></td>
                                    <td className="bold fontsizelarge paddingleft "><span> </span>{Translate("Delete this user")}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr height="20" />
                    
                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">
                        <button className="blackbackground white pointer borderradios buylicencebutton btn btn-dark" onClick={()=>{handleDeleteUser()}}>{Translate("Delete user")}</button> 
                    </td>
                </tr>   
                   
                <tr height="40"/>
            </tbody>
            </table>

            {/*FreeSpace*/}
            <table>
                <tbody>
                    <tr height="80"></tr>
                </tbody>
            </table>

            {/*footerTable*/}
            <table>
                <tbody>
                    <tr height="60"></tr>
                </tbody>
            </table>

            <Footer/>

            {/*Animation part*/}
            <Modal animation={false} style={{opacity:1}} show={mExpireLicence !== ""} onHide={() => SetExpireLicence("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{("Are you sure for expiring this license?")}</span></Modal.Title>
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => ExpireLicence()}>OK</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() =>SetExpireLicence("")}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            {/*Animation part*/}
            <Modal animation={false} style={{opacity:1}} show={mAssignNewLicenceError !== ""} onHide={() => SetAssignNewLicenceError("")} centered={true}>
                <Modal.Header closeButton={true}>
                    <Modal.Title align="center"><span align="center">{
                        (mAssignNewLicenceError === "Not enough licenses" ? Translate("You don't have this license, you can buy it or assign another license.") : "" )}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer align="center">
                    <Button variant="dark" onClick={() => {navigate('../buylicence?tenantguid=' + (mUser ? mUser.TenantGuid : ""));SetAssignNewLicenceError("");}}>{Translate("Buy licenses")}</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="dark" onClick={() =>SetAssignNewLicenceError("")}>Cancel</Button>
                </Modal.Footer>
            </Modal>
            
        </span>
        )
    
}

export default EditUser